import React from 'react';
import {motion} from 'framer-motion';
import Logo from './ui/Logo';

const Hero = () => {
  return (
    <section className="relative h-screen min-h-[800px] flex items-center justify-center overflow-hidden bg-brand-primary">
      <div className="absolute inset-0 z-0">
        {/* Significantly lightened radial gradient for readability (Maintained from previous adjustment) */}
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(0,0,0,0.25)_0%,rgba(0,0,0,0)_70%)] z-10"></div>
        {/* Lightened bottom gradient to preserve more image detail while blending (Maintained from previous adjustment) */}
        <div className="absolute inset-0 bg-gradient-to-t from-brand-primary/60 via-brand-primary/5 to-transparent z-10"></div>
        <img 
          src="https://media-manager-c.questera.ai/greta-media/4948ae8bd3a71eaecd010e3b75a418c9afeda68ebd57283642e35d04cbb3fca3a3104393b4fae87688db585a45c44e03/images/aW1hZ2Uvd2VicA==/efb09108bcad8f4bd2f246ffcf93e4fc.webp" 
          alt="Modern corporate plaza walkway" 
          className="w-full h-full object-cover object-center" 
        />
      </div>
      <div className="container relative z-20 mx-auto px-6 md:px-12 flex flex-col items-center text-center pt-24">
        {/* Larger, Prominent Hero Logo centered above headline */}
        <motion.div 
          initial={{opacity: 0,y: -20}} 
          animate={{opacity: 1,y: 0}} 
          transition={{duration: 1.5,ease: [0.16,1,0.3,1]}} 
          className="mb-12 md:mb-16" 
        >
          <Logo className="w-[110px] md:w-[140px] lg:w-[170px] h-auto" />
        </motion.div>
        
        {/* Hero Headline - Unchanged */}
        <motion.h1 
          initial={{opacity: 0,y: 30}} 
          animate={{opacity: 1,y: 0}} 
          transition={{duration: 1.2,delay: 0.2,ease: [0.16,1,0.3,1]}} 
          className="font-display text-5xl md:text-7xl lg:text-[92px] font-light tracking-tight text-white max-w-6xl leading-[1.02] text-balance mb-14" 
        >
          Building ideas into ventures that move business forward.
        </motion.h1>

        {/* Updated Supporting Paragraph - Exactly as requested */}
        <motion.div 
          initial={{opacity: 0,y: 20}} 
          animate={{opacity: 1,y: 0}} 
          transition={{duration: 1,delay: 0.4}} 
          className="max-w-4xl mb-20" 
        >
          <p className="text-xl md:text-2xl text-white font-light leading-relaxed text-balance opacity-90">
            EPOQ Assets develops and connects ventures across consulting, autonomous mobility, AI talent development and emerging business opportunities, with a focus on practical innovation and long-term value creation.
          </p>
        </motion.div>

        {/* Hero Buttons - Unchanged */}
        <motion.div 
          initial={{opacity: 0}} 
          animate={{opacity: 1}} 
          transition={{duration: 1,delay: 0.8}} 
          className="flex flex-col sm:flex-row gap-10 items-center" 
        >
          <a 
            href="#businesses" 
            className="px-14 py-6 bg-white text-brand-primary text-[14px] tracking-[0.25em] uppercase font-bold hover:bg-brand-light transition-all duration-500 transform hover:-translate-y-1 shadow-2xl" 
          >
            Explore the businesses
          </a>
          <a 
            href="#contact" 
            className="px-14 py-6 border border-white/40 text-white text-[14px] tracking-[0.25em] uppercase font-bold hover:border-brand-accent hover:text-brand-accent hover:bg-brand-accent/5 transition-all duration-500 transform hover:-translate-y-1" 
          >
            Start a conversation
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;